import { DTORichText } from "~/declarations/graphql/types";
import { isNotNullable } from "~/utils/common";

export default function isRichTextEmpty(
  richText: DTORichText | null | undefined
): richText is DTORichText {
  return !isNotNullable(richText) || !richText.text;
}
